/**
 * V2 Invoice Management color tokens.
 *
 * Semantic names so components don't scatter raw hex values.
 * Mirrors COLOR_CONSTANTS where values overlap but is self-contained for v2.
 */
export const V2_COLORS = {
  // --- Primary ---
  primary: "#3655F2",
  primaryHover: "#2B44C1",
  primaryBg: "#EBEEFE",
  primarySoft: "#8C9CF5",

  // --- Success (green) ---
  success: "#469E59",
  successBg: "#DAECDE",
  successSoft: "#387E47",
  successSoftBg: "#EDF5EE",

  // --- Warning (amber) ---
  warning: "#F19E2B",
  warningBg: "#FFF8E1",

  // --- Error (red) ---
  error: "#DB382A",
  errorHover: "#B82E23",
  errorBg: "#FBEBEA",

  // --- Info (blue) ---
  info: "#1976D2",
  infoBg: "#E3F2FD",

  // --- Neutral ---
  textSecondary: "#666",
  border: "#ccc",
  bgMuted: "#F5F5F5",
} as const;
